var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('FeedbackListCard',{attrs:{"search":_vm.search,"feedbacks":{}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }